var _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _circle5, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMisroutedShipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0376 40.4766H29.4922L28.9453 63.9922C28.6719 64.6302 28.7266 65.9609 31.1328 66.1797H81.7188C82.8125 65.9974 85 65.1953 85 63.4453V52.5078L77.3438 40.4766H58.9624C58.4642 46.9237 53.0749 52 46.5 52C39.9251 52 34.5358 46.9237 34.0376 40.4766Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8828 44.8516C76.5234 47.4948 79.8594 52.8906 80.0781 53.3281H67.5V44.8516H74.8828Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7891,
    cy: 64.5391,
    r: 6.28906,
    fill: "#455A64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7891,
    cy: 64.5391,
    r: 2.46094,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7109,
    cy: 64.5391,
    r: 6.28906,
    fill: "#455A64"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.7109,
    cy: 64.5391,
    r: 2.46094,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 52C53.4036 52 59 46.4036 59 39.5C59 36.686 58.0701 34.0892 56.5009 32H60.9604C63.1479 32.2188 63.3302 34.0964 63.1479 35.0078V57.4297L25.4135 57.9766C24.3198 57.7578 23.864 56.6094 23.7729 56.0625C23.3354 54.3125 24.5021 53.5104 25.1401 53.3281H28.1479V49.2266H21.312C19.7807 49.0078 19.3979 47.8594 19.3979 47.3125C18.9604 45.5625 20.4916 44.9427 21.312 44.8516H28.1479V40.4766H16.9369C15.6244 40.2578 15.114 38.9271 15.0229 38.2891C14.8041 36.9766 16.2078 36.1016 16.9369 35.8281H28.1479V34.1875C27.9291 32.6563 29.5151 32.0911 30.3354 32H36.4991C34.9299 34.0892 34 36.686 34 39.5C34 46.4036 39.5964 52 46.5 52Z",
    fill: "#FFC107"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.66,
    cy: 39.66,
    r: 9.66,
    fill: "#E34E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 35.6035L50.8 43.5523",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 43.8005L50.7172 35.5205",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisroutedShipment);
export default __webpack_public_path__ + "static/media/misrouted-shipment.9175aa8d2280a0e190cf9ce7779a5218.svg";
export { ForwardRef as ReactComponent };